module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contacts-form"
    }
  }, [_c('triggers', {
    attrs: {
      "triggers": _vm.flow.triggers,
      "current_user_id": _vm.user_id_or_default
    },
    on: {
      "update-triggers": _vm.updateTriggers
    }
  }), _c('hr'), _c('div', {
    staticClass: "col-sm-6 no-padding"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.contacts')))]), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.contacts')))]), _c('div', {
    staticClass: "number-with-label"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.number_of_contacts))]), _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "upper-label"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.contactS')))]), _c('div', {
    staticClass: "lower-label"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.addS')))])])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "btn btn-clean dropdown-toggle",
    attrs: {
      "id": "add-contacts-dropdown",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.actions.insertContacts')))]), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "id": "contact-picker",
      "data-toggle": "modal",
      "data-target": "#contacts-picker"
    }
  }, [_c('a', {
    staticClass: "clickable",
    attrs: {
      "id": "open-contact-picker"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.actions.contactsBase')))])]), _c('li', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#contacts-manual-picker"
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_vm._v(_vm._s(_vm.$t('flows.actions.manually')))])])])]), _c('contact-picker', {
    attrs: {
      "user_id": _vm.user_id_or_default
    },
    on: {
      "contacts-selected": _vm.selectContacts
    }
  }), _c('contact-manual-picker'), _c('hr'), _c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('flows.label.dragDropProperties')))]), _c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "view_mode": _vm.contactListViewModes().flow_edit,
      "internal_scroller": true,
      "draggable_options": {
        disabled: _vm.any_filter,
        filter: ".undraggable"
      },
      "flow": _vm.flow
    },
    on: {
      "priority-updated": _vm.updateContactsPriority,
      "filter": _vm.filter,
      "scroll-ended": _vm.loadFlowContacts
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var contact = ref.contact;

        return [_c('div', {
          staticClass: "table-col table-col-collapsed show"
        }, [(_vm.current_user.can_manage_templates) ? _c('span', {
          staticClass: "plain-btn-edit clickable-element",
          class: {
            orange: _vm.hasSpecificTemplate(contact)
          },
          on: {
            "click": function($event) {
              return _vm.openSpecificTemplatesModal(contact)
            }
          }
        }) : _vm._e()]), _c('div', {
          staticClass: "table-col table-col-collapsed show"
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-trash clickable-element",
          on: {
            "click": function($event) {
              return _vm.removeContact(contact)
            }
          }
        })])]
      }
    }])
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('contacts.feedback.noMoreResults')))])], 1), _c('specific-templates-modal', {
    attrs: {
      "flow": _vm.flow,
      "contact": _vm.current_contact
    },
    on: {
      "specific-template-add": function($event) {
        return _vm.updateContactsWithSpecificTemplate($event, true)
      },
      "specific-template-destroy": function($event) {
        return _vm.updateContactsWithSpecificTemplate($event, false)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ee337ca!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/contacts_form.vue
// module id = 1064
// module chunks = 1